var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.125 21.1004L6.70005 12.7004C6.60005 12.6004 6.52938 12.4921 6.48805 12.3754C6.44605 12.2587 6.42505 12.1337 6.42505 12.0004C6.42505 11.8671 6.44605 11.7421 6.48805 11.6254C6.52938 11.5087 6.60005 11.4004 6.70005 11.3004L15.125 2.87539C15.3584 2.64206 15.65 2.52539 16 2.52539C16.35 2.52539 16.65 2.65039 16.9 2.90039C17.15 3.15039 17.275 3.44206 17.275 3.77539C17.275 4.10872 17.15 4.40039 16.9 4.65039L9.55005 12.0004L16.9 19.3504C17.1334 19.5837 17.25 19.8711 17.25 20.2124C17.25 20.5544 17.125 20.8504 16.875 21.1004C16.625 21.3504 16.3334 21.4754 16 21.4754C15.6667 21.4754 15.375 21.3504 15.125 21.1004Z",
    fill: "#383940"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBack);
export default __webpack_public_path__ + "static/media/ic-back.7545cd2c341390a2d4562481f22f71ec.svg";
export { ForwardRef as ReactComponent };